import { BobRequest } from "../../model/bob-request";
import { Marker } from "../../model/marker";
import { Microservice } from "../../model/microservice";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";
import { IProcessable } from "../pipeline/processable.interface";

export class MicroserviceIdentifierComponent extends BaseChainableComponent<BobRequest> implements IProcessable<BobRequest> {

	public environment: string | any;
	private page: string;

	constructor(environment: string | any) {

		super();

		this.environment = environment.trim();
		if (this.environment !== ("tst" || "prd")) {

			this.logger.error("No (valid) environment set...", this.environment);
			return;
		}
	}
	/**
	 * Iterates over all markers found and parses the correct URL based on the environment.
	 *
	 * @param input
	 */

	public async process(input: BobRequest) {

		this.page = input.html;
		this.identifyMarkers(input);
		return await this.next.process(input);
	}
	/**
	 * Extract the URL from the marker based on the environment.
	 */

	public getMarkers(): any | null {

		return this.page.match(/<div data-bob*([\s\S]*?(-url)?)<\/div>/g);
	}
	/**
	 * Chooses the correct regex based on the environment.
	 * @param environment - optional environment which overwrites the current environment.
	 */

	public getURLRegex(environment?: string): string {

		let setRegex;
		const env = environment || this.environment;

		if (env === "tst") {
			setRegex = '(?<=data-bob-tst-url=")[^"]+(?=")';
		} else {
			setRegex = '(?<=data-bob-url=")[^"]+(?=")';
		}

		return setRegex;
	}
	/**
	 * Find markers in the requested page response.
	 */

	public getURLFromMarker(marker: string | any, regex: string): any | null {

		return marker.match(regex);
	}
	/**
	 * Get all the markers from the requested page.
	 *
	 * @param input
	 */

	private identifyMarkers(input: BobRequest) {

		const allMarkers: object[] = this.getMarkers();
		if (allMarkers === null) {

			return;
		}

		allMarkers.forEach((marker) => {

			this.processMarker(marker, input);
		});
	}

	/**
	 * Get the URL from the marker being processed.
	 *
	 * @param marker
	 * @param input
	 */

	private processMarker(marker, input: BobRequest) {

		let url = this.getURLFromMarker(marker, this.getURLRegex());
		if (url === null && this.environment === "tst") {

			url = this.getURLFromMarker(marker, this.getURLRegex("prd"));
		}

		if (url === null) {

			this.logger.warn('No "prd" URL found either, skipping placeholder', marker);
			return;
		}

		input.addMicroService(new Microservice(new Marker(url[0])));
	}
}
